import { rootApi } from '../rootApi';

export const preAccountingApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getPreAccountingList: builder.query({
      query: (params) => ({
        url: 'v1/preaccouting/list',
        method: 'GET',
        params: {
          DealerId: params?.DealerId,
          PageNumber: params?.PageNumber ?? 1,
          PageSize: params?.PageSize ?? 10,
          LanguageId: params?.LanguageId ?? 2,
          CustomerType: params?.CustomerType ?? 0,
        },
      }),
      providesTags: ['PreAccounting'],
    }),

    getPreAccountingCustomers: builder.query({
      query: (params) => ({ 
        url: 'v1/preaccouting/customers', 
        method: 'GET',
        params: {
            SearchText: params?.SearchText || '',
            RowCount: params?.RowCount || 50
        }
       }),
      transformResponse: (resp) => resp?.data ?? [],
      providesTags: ['PreAccountingCustomers'],
    }),

    exportPreAccounting: builder.query({
      query: (params) => ({
        url: 'v1/preaccouting/exportPreAccounting',
        method: 'GET',
        params: {
          DealerId: params.DealerId,
          LanguageId: params.LanguageId,
          CompressionType: params.CompressionType ?? 0,
        },
      }),
      transformResponse: (response) => {
        if (response?.isSuccessful && response?.data) {
          const data = response.data;
          return {
            fileBase64: data.fileBase64,
            fileName: data.fileName,
            contentType: data.contentType,
            recordCount: data.recordCount,
            fileSize: data.fileSize,
            isCompressed: data.isCompressed,
          };
        }
        throw new Error(response?.errorMessage || 'Export failed');
      },
    }),

    getPreAccountingSelectedTypes: builder.query({
      query: (params) => ({
        url: 'v1/preaccouting/selected-types',
        method: 'GET',
        params: { LanguageId: params?.LanguageId ?? 2 },
      }),
      transformResponse: (resp) => resp?.data ?? {},
      providesTags: ['PreAccountingSelectedTypes'],
    }),

    addPreAccounting: builder.mutation({
      query: (data) => ({
        url: 'v1/preaccouting/add-pre-account',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['PreAccounting'],
    }),

    getPreAccountingKdv: builder.query({
      query: () => ({
        url: 'v1/preaccouting/kdv',
        method: 'GET',
      }),
      transformResponse: (resp) => resp?.data ?? null,
    }),
  }),
});

export const {
  useGetPreAccountingListQuery,
  useGetPreAccountingCustomersQuery,
  useGetPreAccountingSelectedTypesQuery,
  useAddPreAccountingMutation,
  useLazyExportPreAccountingQuery,
  useGetPreAccountingKdvQuery,
  useLazyGetPreAccountingKdvQuery
} = preAccountingApi;
